import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import NumericQuestionViewModel from '../../NumericQuestionViewModel'

export default function NumericValue({
  vm,
}: ValueComponentProps<NumericQuestionViewModel>) {
  return <>{vm.toTextAnswer()}</>
}
